import { ASSETS_BASE_URL } from './apiConfig';

const normalizeBaseUrl = (url: string): string => String(url || '').replace(/\/+$/, '');

export const getAssetsBaseUrl = (): string => ASSETS_BASE_URL;

const UPLOADS_SEGMENT = '/uploads/';

const joinUrl = (base: string, path: string): string => {
  const normalizedBase = normalizeBaseUrl(base);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

export const resolveAssetUrl = (value?: string | null): string => {
  if (!value) return '';
  const raw = String(value).trim();
  if (!raw) return '';

  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:')) return raw;

  const normalizedSlashes = raw.replace(/\\/g, '/');
  if (/^[a-zA-Z]:\//.test(normalizedSlashes) || normalizedSlashes.startsWith('file:')) return '';

  const lowerNormalized = normalizedSlashes.toLowerCase();
  const uploadsIndex = lowerNormalized.indexOf(UPLOADS_SEGMENT);
  if (uploadsIndex >= 0) {
    return joinUrl(getAssetsBaseUrl(), normalizedSlashes.substring(uploadsIndex));
  }

  if (lowerNormalized.startsWith('uploads/')) {
    return joinUrl(getAssetsBaseUrl(), `/${normalizedSlashes}`);
  }

  return joinUrl(getAssetsBaseUrl(), normalizedSlashes);
};

